import { render, staticRenderFns } from "./PuckList.vue?vue&type=template&id=63a4ee21"
import script from "./PuckList.vue?vue&type=script&lang=js"
export * from "./PuckList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports